import type { PickEmPrize } from '../../model/pickem/PickEmTypes';

/**
 * Default 9-prize pool for the pick-em demo. Mix of low / mid / high
 * coin values + one jackpot — picks of 3 typically score 100-400, with
 * the jackpot picker landing 600+. cs-core's MMS uses similar curves
 * for "interrogate the suspect" mini-bonuses.
 */
export const DEFAULT_PICK_EM_PRIZES: readonly PickEmPrize[] = [
  { value: 25 },
  { value: 25 },
  { value: 50 },
  { value: 50 },
  { value: 100 },
  { value: 100 },
  { value: 200 },
  { value: 250 },
  { value: 500, label: 'JACKPOT', tint: 0xff3b6b },
];
